// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na.no-uline[data-v-61308be7]:hover{\n  text-decoration:underline\n}\n", ""]);
// Exports
module.exports = exports;
